/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { fromCents, getCurrencyCode, getInvoiceAmount } from 'utils/helpers';
import AccordionTooltip from 'components/common/controls/AccordionTooltip';
import UnpaidInvoiceItemMobile from 'components/Credit24/SelfService/Invoices/UnpaidInvoiceItemMobile';

const propTypes = {
  contractId: PropTypes.string.isRequired,
  invoice: PropTypes.object.isRequired,
  mobileWalletToken: (MOBILE_WALLET ? PropTypes.string.isRequired : PropTypes.string),
};

const OpenInvoiceSectionMobile = ({ invoice, contractId, mobileWalletToken }) => {
  const invoiceAmount = fromCents(getInvoiceAmount(invoice));

  return (
    <>
      <AccordionTooltip
        title={<FormattedMessage id="selfservice.dashboard.invoice.pending" />}
        mod="centered"
        hideIcon
      >
        <p className="txt-center">
          <FormattedMessage id="selfservice.invoices.paymentDateInfo" />
        </p>
      </AccordionTooltip>
      {MOBILE_WALLET && <br />}
      <div className="invoice-item invoice-item--type-centered">
        <h2 className="invoice-item__amount txt-base">
          <FormattedNumber
            style="currency"
            currency={getCurrencyCode()}
            value={invoiceAmount}
          />
        </h2>
        <AccordionTooltip
          title={<FormattedMessage id="selfservice.invoices.open.details" />}
          mod="centered"
          hideIcon
        >
          <UnpaidInvoiceItemMobile
            key={invoice.id}
            invoice={invoice}
            contractId={contractId}
            mobileWalletToken={mobileWalletToken}
            showInvoiceNumber={COUNTRY !== 'AU'}
          />
        </AccordionTooltip>
      </div>
    </>
  );
};

OpenInvoiceSectionMobile.propTypes = propTypes;

export default OpenInvoiceSectionMobile;
